import React, { useState } from 'react';
import { freeFetch } from './api';

const WITHDRAW_MESSAGE =
  "Unticking this deletes every note you have written about pain, injury or health: your discomfort notes and your check-in answers about what is getting in the way. Your sessions stay.";

const smallBtn =
  'font-heading text-xs font-bold uppercase tracking-wider rounded-none px-4 py-2 transition-colors';

// Explicit consent for special category (health) data. Stored on the user record.
export function HealthConsent({ granted, onChange, testid }) {
  const [confirmingWithdraw, setConfirmingWithdraw] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const save = async (value) => {
    setBusy(true);
    setError('');
    try {
      await freeFetch('/consent/health', { method: 'PUT', body: JSON.stringify({ granted: value }) });
      onChange(value);
      setConfirmingWithdraw(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const toggle = (e) => (e.target.checked ? save(true) : setConfirmingWithdraw(true));

  return (
    <div className="mb-3" data-testid={testid}>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={granted}
          onChange={toggle}
          disabled={busy || confirmingWithdraw}
          className="mt-0.5 h-4 w-4 flex-shrink-0 accent-white cursor-pointer"
          data-testid={`${testid}-checkbox`}
        />
        <span className="text-mono-mute text-xs font-body leading-relaxed" data-testid={`${testid}-text`}>
          I agree that Coach Rands can store what I write here about pain, injury or health so it can track my
          training. See{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-white underline hover:text-mono-mute">
            Privacy
          </a>
          .
        </span>
      </label>
      {confirmingWithdraw && (
        <div className="border border-mono-line bg-mono-surface p-4 mt-3" data-testid={`${testid}-withdraw-confirm`}>
          <p className="text-white text-sm font-body leading-relaxed">{WITHDRAW_MESSAGE}</p>
          <div className="flex flex-wrap gap-2 mt-3">
            <button
              type="button"
              onClick={() => save(false)}
              disabled={busy}
              className={`${smallBtn} bg-white text-black hover:bg-[#E5E5E5] disabled:opacity-50`}
              data-testid={`${testid}-withdraw-confirm-btn`}
            >
              {busy ? 'Deleting...' : 'Untick and delete notes'}
            </button>
            <button
              type="button"
              onClick={() => setConfirmingWithdraw(false)}
              disabled={busy}
              className={`${smallBtn} border border-mono-line text-mono-mute hover:text-white`}
              data-testid={`${testid}-withdraw-cancel-btn`}
            >
              Keep my consent
            </button>
          </div>
        </div>
      )}
      {error && <p className="text-red-400 text-xs font-body mt-2" data-testid={`${testid}-error`}>{error}</p>}
    </div>
  );
}
